import CompareMembership from 'blocks/CompareMembership/CompareMembership';
import DownloadApp from 'blocks/DownloadApp/DownloadApp';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import MembershipHero from 'blocks/MembershipHero/MembershipHero';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import type { GetStaticProps, NextPage } from 'next';
import PageService from 'services/PageService/PageService';
import { IGenericPage, IMembershipPage } from 'types/interfaces';
import membershipsData from 'data/memberships.json';

interface IMembershipPageInterface extends IMembershipPage, IGenericPage {}

const Membership: NextPage<IMembershipPageInterface> = ({
  globalLayoutProps,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <MembershipHero />
      <CompareMembership
        memberships={membershipsData.memberships.map(membership => {
          return {
            ...membership,
            prices:
              globalLayoutProps.memberships.find(
                globalMembership => globalMembership.id === membership.id
              )?.prices || membership.prices,
          };
        })}
        features={membershipsData.features}
        currencies={globalLayoutProps.currencies}
      />
      <DownloadApp />
    </GlobalLayout>
  );
};

export default Membership;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.MEMBERSHIP,
  });
  const membershipPageProps = await PageService.getMembershipPageProps();

  return {
    props: {
      ...genericPageProps,
      ...membershipPageProps,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
